import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
import HomeIcon from "@material-ui/icons/Home";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import ManageUsersIcon from "@material-ui/icons/VpnKey";

import { NavLink as RouterLink } from "react-router-dom";
import ProtectedContent from "../protectedContent/ProtectedContent";

interface Props {
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: 240,
    },
    toolbar: theme.mixins.toolbar,
    logo: {
      width: "125%",
      marginTop: "18px",
      marginBottom: "18px",
      marginLeft: "50%",
      transform: "translateX(-50%)"
    },
    link: {
      color: "#fff",
      width: "calc(100% + 10px)",
      "&:hover, &:focus": {
        backgroundColor: "rgba(12,39,47,0.6)",
      },
      "& .MuiListItemIcon-root": {
        color: "#fff",
      },
    },
    activeLink: {
      backgroundColor: "rgba(12,39,47,0.4)",
      width: "calc(100% + 10px)",
      "&:hover, &:focus": {
        backgroundColor: "rgba(12,39,47,0.4)",
      },
    },
  })
);

const Navigation: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classes.list}
      role="presentation"
      onClick={() => props.toggleDrawer(true)}
      onKeyDown={() => props.toggleDrawer(false)}
    >
      <div className={classes.toolbar}>
        <RouterLink to="/">
        <img src="/assets/img/logo.svg" className={classes.logo} />
        </RouterLink>
      </div>
      <Divider />
      <List>
        <ListItem
          button
          component={RouterLink}
          to="/"
          onClick={() => { window.location.href = '/' }}
          exact
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary={"Home / Tickets"} />
        </ListItem>
        <ListItem
          button
          component={RouterLink}
          to="/customer-list"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary={"Kunden"} />
        </ListItem>
          <ListItem
            button
            component={RouterLink}
            to="/user-list"
            className={classes.link}
            activeClassName={classes.activeLink}
          >
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary={"Benutzer"} />
          </ListItem>
      </List>
      <Divider />
    </div>
  );
};

export default Navigation;
